module.exports = __webpack_public_path__ + "b899401c186d3a9129e6c921ec506fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/catherine-meade.jpg
// module id = 660
// module chunks = 0